// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xe1n","footer":"styles_footer__Bkpl2","passCodeTooltip":"styles_passCodeTooltip__ULWbl"};